import { Group, Stack } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import PrimaryButton from 'app/views/components/buttons/PrimaryButton'
import FormWrapper from 'app/views/components/Form/FormWrapper'
import BlackTextInput from 'app/views/components/inputs/BlackTextInput'
import RichTextEditorInput from 'app/views/components/rich-text-editor-input/rich-text-editor-input'


type EntitiesFormProps = {
    form: UseFormReturnType<any>
    isLoading: boolean;
    isStepper?: boolean;
    mandatoryFields: string[]
    submitForm: any;
    transformValues: (values: Record<string, any>) => any;
    submitAndExit: () => void;
    exitForm: () => void;
    handleBulkNotificationAndClosure: () => void;
}

export default function EntitiesFormSignatureBlock({
    form,
    isLoading,
    submitAndExit,
    submitForm,
}: EntitiesFormProps) {
    return (
        <FormWrapper title={"Add Signature Block"}>
            <div className='signature-block-form'>
                <div className="signature-block-content">
                    <div className='signature-block-wrapper'>
                        <RichTextEditorInput
                            form={form}
                            fieldName="signatureBlock.signatureText"
                            placeholder="Write signature block text here..."
                            isMandatory={false}
                            height={162}
                            allowBold={false}
                            allowItalic={false}
                            allowUnderline={false}
                            allowLink={false}
                            allowUnlink={false}
                            allowH1={false}
                            allowH2={false}
                            allowH3={false}
                            allowAlignLeft={false}
                            allowAlignCenter={false}
                            allowAlignRight={false}
                        />
                    </div>
                    <Group w='100%'>
                        <BlackTextInput label="Full Name" placeholder='Enter Full Name' {...form.getInputProps('signatureBlock.signatureName')} />
                    </Group>
                    <Group w='100%'>
                        <BlackTextInput label="Title" placeholder='Enter Title' {...form.getInputProps('signatureBlock.signatureTitle')} />
                    </Group>
                    <Group w='100%'>
                        <BlackTextInput label="Email" placeholder='Enter Email' {...form.getInputProps('signatureBlock.signatureEmail')} />
                    </Group>
                    <Stack w="100%">
                        <div
                            style={{
                                marginTop: '1rem',
                                display: 'flex',
                                gap: '.5rem',
                                justifyContent: 'flex-end',
                            }}
                        >
                            <Group noWrap w="100%" position='apart'>
                                <PrimaryButton
                                    disabled={!form.isValid()}
                                    className="form-button"
                                    loading={isLoading}
                                    onClick={(event) => submitForm(event)}
                                    w="100%"
                                >
                                    Save and Proceed
                                </PrimaryButton>
                                <PrimaryButton
                                    disabled={!form.isValid()}
                                    className="form-button"
                                    loading={isLoading}
                                    onClick={() => submitAndExit()}
                                    w="100%"
                                >
                                    Save and Exit
                                </PrimaryButton>
                            </Group>
                        </div>
                    </Stack>
                </div>
            </div>
        </FormWrapper>
    )
}